import {createContext} from '@lit-labs/context';

import type {FeatureFlagKey} from '#lit/lib/feature_flags/FeatureFlag.js';
import type {Nullable} from '#lit/types/general.js';
import type {User} from '#lit/types/user.js';

export type SessionContextData = {
  user: () => Nullable<User>;
  embed: () => boolean;
  enabled: (...keys: FeatureFlagKey[]) => boolean;
};

export const SessionContext =
  createContext<SessionContextData>('session-context');
